export default __webpack_public_path__ + "static/media/logo-ipad.06c6673a.svg";